angular.module('app').factory('LoginAssistanceRepository',
    ['NgxLoginAssistanceRepository', function (NgxLoginAssistanceRepository) {
        'use strict';

        function getLoginAssistanceInformation (clientId) {
            return NgxLoginAssistanceRepository.getLoginAssistanceInformation({ ClientId: clientId }).toPromise();
        }

        return{
            getLoginAssistanceInformation: getLoginAssistanceInformation
        };
    }]);